import {
  Paper,
  Typography,
  Stack,
  Box,
  useTheme,
  Tooltip,
  Button,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";

import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  Dangerous,
  Error,
  LocalFireDepartment,
  MoreVert,
  ReplyAll,
  ReportProblem,
} from "@mui/icons-material";
import ModalAcknowledge from "../../modalAcknowledge";
import { useMapa } from "../../../../contexts/mapaContext";

export default function CardAlerts(props) {
  const { alert, setFocusNodeId } = props;
  const { isPublic = false } = useMapa();
  const theme = useTheme();
  const [typeCard, setTypeCard] = useState({});
  const [openAcknowledgeModal, setOpenAcknowledgeModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);

  useEffect(() => {
    function type() {
      return alert?.severity == 2
        ? {
            cor: theme.palette.color.zabbixSeverty.warning,
            icon: (
              <ReportProblem
                sx={{
                  color: theme.palette.color.zabbixSeverty.warning,
                  fontSize: "26px",
                }}
              />
            ),
            title: "Alerta",
          }
        : alert?.severity == 3
        ? {
            cor: theme.palette.color.zabbixSeverty.average,
            icon: (
              <Error
                sx={{
                  color: theme.palette.color.zabbixSeverty.average,
                  fontSize: "26px",
                }}
              />
            ),
            title: "Alerta Moderado",
          }
        : alert?.severity == 4
        ? {
            cor: theme.palette.color.zabbixSeverty.high,
            icon: (
              <Dangerous
                sx={{
                  color: theme.palette.color.zabbixSeverty.high,
                  fontSize: "26px",
                }}
              />
            ),
            title: "Alerta de alto impacto",
          }
        : {
            cor: theme.palette.color.zabbixSeverty.disaster,
            icon: (
              <LocalFireDepartment
                sx={{
                  color: theme.palette.color.zabbixSeverty.disaster,
                  fontSize: "26px",
                }}
              />
            ),
            title: "Alerta de Desastre",
          };
    }
    setTypeCard(type());
  }, [alert]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOpenAcknowledgeModal = (event) => {
    event.stopPropagation();
    setOpenAcknowledgeModal(true);
    setAnchorEl(null);
  };

  const styles = {
    title: {
      fontSize: "0.9em",
      maxWidth: "220px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      textAlign: "left",
    },
    message: {
      fontSize: "0.8em",
      maxWidth: "220px",
      textAlign: "left",
      WebkitLineClamp: 2,
      display: "-webkit-box",
      "-webkit-line-clamp": 2,
      "-webkit-box-orient": "vertical",
      color: theme.palette.color.textDisabled,

      overflow: "hidden",
      textOverflow: "ellipsis",
    },
    line: {
      backgroundColor: typeCard.cor,
      height: "80%",
      width: "2px",
      right: 0,
      position: "absolute",
    },
    card: {
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #0000001a",
      position: "relative",
      width: "100%",

      height: "90px",
      alignItems: "center",
    },
    buttonCard: {
      color: "inherit",
      padding: "15px 10px",
      display: "flex",
      direction: "row",
      justifyContent: "flex-start",
      width: "100%",
      height: "100%",
      gap: 1.5,
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },
    },
  };

  return (
    <>
      <Paper elevation={0} sx={styles.card}>
        <Tooltip title={alert?.name} placement="left">
          <Button
            onClick={() => setFocusNodeId(alert?.elementId)}
            sx={styles.buttonCard}
          >
            {typeCard.icon}
            <Stack direction={"column"} alignItems="start">
              <Typography sx={styles.title}>
                {typeCard?.title?.toUpperCase()}
              </Typography>
              <Typography sx={[styles.message, { mt: "-3px", mb: "2px" }]}>
                {dayjs(new Date(alert?.clock * 1000)).format(
                  "DD/MM/YYYY HH:mm"
                )}
              </Typography>
              <Typography
                sx={{
                  ...styles.message,
                }}
              >
                {alert?.name}
              </Typography>
            </Stack>
            {/* <Box sx={styles.line} /> */}
          </Button>
        </Tooltip>
        {!isPublic && (
          <>
            <Tooltip title="Opções" placement="right">
              <IconButton
                onClick={(event) => {
                  handleClick(event);
                }}
                size="small"
                sx={{
                  position: "absolute",
                  right: "4px",
                  top: "4px",
                  color: theme.palette.color.icon,
                }}
              >
                <MoreVert />
              </IconButton>
            </Tooltip>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={() => setAnchorEl(null)}
              anchorOrigin={{
                vertical: "center",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "center",
                horizontal: "left",
              }}
            >
              <MenuItem
                sx={{ display: "flex", gap: "8px" }}
                onClick={handleOpenAcknowledgeModal}
              >
                <ReplyAll sx={{ fontSize: "20px" }} /> Reconhecer Alerta
              </MenuItem>
            </Menu>
          </>
        )}
      </Paper>
      <ModalAcknowledge
        key={"ack" + alert?.eventid}
        open={!isPublic && openAcknowledgeModal}
        onClose={() => setOpenAcknowledgeModal(false)}
        alertData={alert || null}
      />
    </>
  );
}
